const ROUTES = '{"SALE_VIEW_DATA": {"name": "Venta", "route":"venta"}, "RENT_VIEW_DATA": {"name": "Alquiler", "route":"alquiler"}, "TEMPORARY_VIEW_DATA" : {"name": "Temporario", "route":"temporario"}}'

module.exports = ROUTES;